module.exports = {
    SPORT_EVENT_GET: 'SPORT_EVENT_GET',
};
